import type { FaireProductEntity } from "../../entity_types/product";

export const p_3dbzjmnsy9: FaireProductEntity = {
  token: "p_3dbzjmnsy9",
  type: "product",
  name: "Color Block Striped Oversized Knit Sweater Women",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/f29bcee6718dbff58c5978356157c3232397b6affc1f2b46fe39cee7fd401f0f.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86767220aa3a9498721b1f8bbef8c8452c5936ed14a3fb0e8dd423a0dc7d6e58.webp",
    "https://cdn.faire.com/fastly/b8edef279286dec7f273cf156dc5432a41c2eaaf0d3b8aecf0ff819eb5c73d55.webp",
    "https://cdn.faire.com/fastly/e919aa87f1aa5b1a48a6c8177ee0acb30cb53a65c9e3b9a4ddd04e75c6c28a44.webp",
  ],
  priceDollars: 19.43,
  description:
    "Soft Lightweight Knit\nMade from soft, breathable knit fabric that feels cozy without heaviness, perfect for layering across seasons.\n\nBold Color Block Stripes\nFeatures vibrant contrast stripes that create a playful, eye-catching look, ideal for standout boutique displays.\n\nOversized Relaxed Fit\nDesigned with a slouchy oversized silhouette and drop shoulders for a laid-back, comfortable fit that suits all body types.\n\nCasual Trendy Style\nRibbed neckline, cuffs, and hem add structure while maintaining a relaxed, effortless aesthetic.\n\nVersatile Styling Piece\nPairs easily with denim shorts, jeans, or leggings—perfect for casual outings, vacations, and everyday wear.\n\nBoutique Trend Favorite\nStriped oversized sweaters remain a strong trend, offering great visual appeal and high sell-through potential.\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_kzks8vegvk",
  tags: [],
  msrpDollars: 38.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:59.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
